import * as React from "react";
import { Drawer } from "vaul";
import { cn } from "@repo/exit-calc-web-utils";

function BottomSheet({
  children,
  ...props
}: React.ComponentProps<typeof Drawer.Root>) {
  return (
    <Drawer.Root noBodyStyles repositionInputs={false} {...props}>
      {children}
    </Drawer.Root>
  );
}

const BottomSheetTrigger: typeof Drawer.Trigger = Drawer.Trigger;

const BottomSheetClose: typeof Drawer.Close = Drawer.Close;

const BottomSheetPortal: typeof Drawer.Portal = Drawer.Portal;

function BottomSheetOverlay({
  className,
  ...props
}: React.ComponentProps<typeof Drawer.Overlay>) {
  return (
    <Drawer.Overlay
      className={cn("fixed inset-0 z-50 bg-black/40", className)}
      {...props}
    />
  );
}

function BottomSheetContent({
  className,
  children,
  ...props
}: React.ComponentProps<typeof Drawer.Content>) {
  return (
    <BottomSheetPortal>
      <BottomSheetOverlay />
      <Drawer.Content
        className={cn(
          "fixed inset-x-0 bottom-0 z-50 flex max-h-[85dvh] flex-col rounded-t-2xl border-t bg-background",
          className,
        )}
        style={{ paddingBottom: "var(--safe-area-inset-bottom)" }}
        {...props}
      >
        <div className="mx-auto mt-3 mb-2 h-1.5 w-12 shrink-0 rounded-full bg-muted-foreground/20" />
        {children}
      </Drawer.Content>
    </BottomSheetPortal>
  );
}

function BottomSheetHeader({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("flex flex-col gap-1.5 px-4 pb-3 text-center", className)}
      {...props}
    />
  );
}

function BottomSheetTitle({
  className,
  ...props
}: React.ComponentProps<typeof Drawer.Title>) {
  return (
    <Drawer.Title
      className={cn("text-lg font-semibold text-foreground", className)}
      {...props}
    />
  );
}

function BottomSheetDescription({
  className,
  ...props
}: React.ComponentProps<typeof Drawer.Description>) {
  return (
    <Drawer.Description
      className={cn("text-sm text-muted-foreground", className)}
      {...props}
    />
  );
}

function BottomSheetFooter({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("flex flex-col gap-2 px-4 py-3", className)}
      {...props}
    />
  );
}

export {
  BottomSheet,
  BottomSheetTrigger,
  BottomSheetClose,
  BottomSheetContent,
  BottomSheetHeader,
  BottomSheetTitle,
  BottomSheetDescription,
  BottomSheetFooter,
};
